<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Consulta de Personal Autorizado</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Consulta de Personal Autorizado</h3>
    </div>

    <!-- FILTROS -->
    <div class="block-content">
      <div class="form-horizontal">
        <app-acceso-filtros-busqueda
            [modelFilter]="modelFilter"
          ></app-acceso-filtros-busqueda>
      </div>
    </div>

    <!-- RESULTADOS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            
            <a
              class="btn btn-celeste"
              mat-raised-button
              (click)="export()"
              ><mat-icon>table_chart</mat-icon> Exportar</a
            >
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"
            ><mat-icon>search</mat-icon> Buscar</a
          >
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="modelListaAccesos"
          class="table table-striped table-vcenter"
        >
          <ng-container matColumnDef="codigo_solicitud">
            <th mat-header-cell *matHeaderCellDef>Código Solicitud</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.codigoSolicitud }}
            </td>
          </ng-container>

          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
          </ng-container>

          <ng-container matColumnDef="trabajador">
            <th mat-header-cell *matHeaderCellDef>Trabajador</th>
            <td mat-cell *matCellDef="let element">
              {{ element.nombres }} {{ element.apellidoPaterno }}
              {{ element.apellidoMaterno }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nroDocumentoIdentidad">
            <th mat-header-cell *matHeaderCellDef>Nro Documento Identidad</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.nroDocumentoIdentidad }}
            </td>
          </ng-container>

          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.sede }}
            </td>
          </ng-container>

          <ng-container matColumnDef="solicitante">
            <th mat-header-cell *matHeaderCellDef>Solicitante</th>
            <td mat-cell *matCellDef="let element">
              {{ element.solicitante }}
            </td>
          </ng-container>

          <ng-container matColumnDef="subcontratista">
            <th mat-header-cell *matHeaderCellDef>Subcontratista</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.subContratista }}
            </td>
          </ng-container>
          
          <ng-container matColumnDef="fecha_aprobacion">
            <th mat-header-cell *matHeaderCellDef>Fecha Aprobación</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaAprobacion | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element" class="centre">
                {{ element.estado }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha_inicio">
            <th mat-header-cell *matHeaderCellDef>Fecha Inicio</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaInicio | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha_fin">
            <th mat-header-cell *matHeaderCellDef>Fecha Fin</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaFin | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>QR</th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-icon-button
                color="primary"
                aria-label="Ver"
                (click)="openDialog(element.idAccesoPersonal)"
              >Ver
              <!-- [routerLink]="['/acceso-personal', element.idAccesoPersonal]" -->
                <!-- <mat-icon>remove_red_eye</mat-icon> -->
            </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator
          #paginator
          [length]="resultsLength"
          [pageSize]="30"
          (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- <pre>{{ modelListaInducciones | json}}</pre> -->

